(() => {
  let cartTrigger = null;
  let cartBusy = false;
  const drawer = () => document.querySelector('[data-pp-cart]');
  const setCartPending = pending => {
    const panel = drawer();
    if (!panel) return;
    panel.toggleAttribute('aria-busy', pending);
    let status = panel.querySelector('[data-pp-cart-loading]');
    if (!status && pending) {
      status = document.createElement('p');
      status.dataset.ppCartLoading = '';
      status.setAttribute('role', 'status');
      status.textContent = 'Actualizando tu carrito…';
      status.style.cssText = 'padding:18px 0;text-align:center;font-size:14px;margin:0';
      panel.querySelector('.pp-cart-body').prepend(status);
    }
    if (status) status.hidden = !pending;
    panel.querySelectorAll('[data-pp-cart-quantity], [data-pp-cart-input], [data-pp-cart-checkout]').forEach(el => el.disabled = pending);
    const empty = panel.querySelector('.pp-cart-empty');
    if (empty) empty.hidden = pending;
  };
  const cartFocusables = () => [...drawer().querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), [tabindex="0"]')].filter(el => el.tabIndex >= 0 && el.getClientRects().length);
  const openCart = trigger => {
    if (!drawer()) return;
    cartTrigger = trigger || document.activeElement;
    drawer().hidden = false;
    document.body.classList.add('pp-cart-open');
    if (document.querySelector('main')) document.querySelector('main').inert = true;
    drawer().querySelector('.pp-cart-close').focus();
  };
  const closeCart = () => {
    if (!drawer()) return;
    drawer().hidden = true;
    document.body.classList.remove('pp-cart-open');
    if (document.querySelector('main')) document.querySelector('main').inert = false;
    if (cartTrigger?.isConnected) cartTrigger.focus();
  };
  const renderCart = state => {
    const html = state.sections?.['cart-drawer'];
    const parsed = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pp-cart-shell]');
    if (!parsed) throw new Error('No se pudo actualizar el carrito. Recarga la página para revisar tus artículos.');
    const shell = document.querySelector('[data-pp-cart-shell]');
    shell.replaceWith(parsed);
  };
  const mutateCart = async (endpoint, body) => {
    const root = drawer().dataset.root;
    const response = await fetch(root + 'cart/' + endpoint + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: ['cart-drawer'], sections_url: window.location.pathname })
    });
    const state = await response.json();
    if (!response.ok) throw new Error(state.description || 'No se pudo actualizar el carrito. Inténtalo de nuevo.');
    const wasOpen = !drawer().hidden;
    renderCart(state);
    if (wasOpen) openCart(cartTrigger);
  };
  const updateCart = async (endpoint, body) => {
    if (cartBusy) return;
    cartBusy = true;
    setCartPending(true);
    drawer().querySelectorAll('[data-pp-cart-quantity], [data-pp-cart-add], [data-pp-cart-input], [data-pp-cart-checkout]').forEach(el => el.disabled = true);
    try { await mutateCart(endpoint, body); }
    catch (problem) {
      const error = drawer().querySelector('[data-pp-cart-error]');
      error.textContent = problem.message; error.hidden = false;
      drawer().querySelectorAll('[data-pp-cart-quantity], [data-pp-cart-add], [data-pp-cart-input], [data-pp-cart-checkout]').forEach(el => el.disabled = false);
    } finally { cartBusy = false; setCartPending(false); }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.matches('[data-pp-cart-open]')) openCart(button);
    if (button.matches('[data-pp-cart-close]')) closeCart();
    if (button.matches('[data-pp-cart-quantity]')) updateCart('change', { id: button.dataset.key, quantity: Number(button.dataset.quantity) });
    if (button.matches('[data-pp-cart-add]')) updateCart('add', { items: [{ id: Number(button.dataset.variant), quantity: 1 }] });
    if (button.matches('[data-pp-cart-prev], [data-pp-cart-next]')) drawer().querySelector('[data-pp-cart-recommendations]').scrollBy({ left: button.hasAttribute('data-pp-cart-prev') ? -350 : 350, behavior: 'smooth' });
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-pp-cart-input]')) return;
    const value = Number(event.target.value);
    if (!Number.isInteger(value) || value < 0) { event.target.value = event.target.dataset.previous; return; }
    updateCart('change', { id: event.target.dataset.key, quantity: value });
  });
  document.addEventListener('keydown', event => {
    if (!drawer() || drawer().hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeCart(); }
    if (event.key === 'Tab') {
      const elements = cartFocusables();
      if (event.shiftKey && document.activeElement === elements[0]) { event.preventDefault(); elements.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === elements.at(-1)) { event.preventDefault(); elements[0].focus(); }
    }
  });
  const initialize = (scope = document) => {
    const motion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    scope.querySelectorAll('[data-pp-hero]').forEach(video => {
      if (video.dataset.heroInitialized) return;
      video.dataset.heroInitialized = 'true';
      const start = () => {
        if (!motion) return;
        video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        video.load();
        video.play().catch(() => {});
      };
      if (video.readyState >= 2) start();
      else if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    });
    scope.querySelectorAll('[data-pp-gallery]').forEach(gallery => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      const track = gallery.querySelector('[data-pp-gallery-track]');
      const thumbs = [...gallery.querySelectorAll('[data-gallery-index]')];
      const slides = [...track.children];
      const loadSlide = index => {
        const template = slides[index]?.querySelector('template[data-gallery-image]');
        if (!template) return;
        const content = template.content.cloneNode(true);
        content.querySelector('img').loading = 'eager';
        template.replaceWith(content);
      };
      if ('IntersectionObserver' in window) {
        const images = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          loadSlide(slides.indexOf(entry.target));
        }), { root: track, threshold: 0.01 });
        slides.forEach(slide => images.observe(slide));
      } else slides.forEach((slide, index) => loadSlide(index));
      let index = 0;
      const go = next => { index = Math.max(0, Math.min(thumbs.length - 1, next)); loadSlide(index); track.scrollTo({ left: index * track.clientWidth, behavior: motion ? 'smooth' : 'auto' }); };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => go(i)));
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(index - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(index + 1));
      track.addEventListener('scroll', () => { index = Math.round(track.scrollLeft / track.clientWidth); thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index))); const hero=gallery.querySelector('[data-pp-hero]'); if(hero){if(index!==0)hero.pause();else if(motion&&hero.readyState>=2)hero.play().catch(()=>{});} }, { passive: true });
    });

    scope.querySelectorAll('[data-pp-carousel]').forEach(carousel => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      const track = carousel.querySelector('.pp-carousel-track');
      if (!track) return;
      const slides = [...track.children];
      const dots = [...carousel.querySelectorAll('[data-carousel-index]')];
      const previous = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      const step = () => (slides[0]?.getBoundingClientRect().width || 0) + (parseFloat(getComputedStyle(track).columnGap) || 0);
      const currentIndex = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (step() || 1))));
      const go = index => track.scrollTo({ left: index * step(), behavior: motion ? 'smooth' : 'auto' });
      const update = () => {
        const index = currentIndex();
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        if (carousel.dataset.carouselWrap === 'true' && previous) previous.hidden = index === 0;
      };
      const move = direction => {
        if (!slides.length) return;
        if (dots.length || carousel.dataset.carouselWrap === 'true') {
          let index = currentIndex() + direction;
          if (carousel.dataset.carouselWrap === 'true') index = (index + slides.length) % slides.length;
          else index = Math.max(0, Math.min(slides.length - 1, index));
          go(index);
        } else track.scrollBy({ left: direction * step(), behavior: motion ? 'smooth' : 'auto' });
      };
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
      let pendingFrame = 0;
      track.addEventListener('scroll', () => {
        if (pendingFrame) return;
        pendingFrame = requestAnimationFrame(() => { pendingFrame = 0; update(); });
      }, { passive: true });
      track.addEventListener('keydown', event => {
        if (!dots.length || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      if (dots.length && 'ResizeObserver' in window) {
        let width = track.clientWidth;
        const resize = new ResizeObserver(() => {
          if (track.clientWidth === width) return;
          const selected = dots.findIndex(dot => dot.getAttribute('aria-pressed') === 'true');
          width = track.clientWidth;
          track.scrollTo({ left: Math.max(0, selected) * step(), behavior: 'auto' });
          update();
        });
        resize.observe(track);
      }
      update();
    });
    scope.querySelectorAll('[data-pp-product]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const form = section.querySelector('.pp-product-form');
      if (!form) return;
      const select = form.querySelector('select[data-pp-variant]');
      const add = form.querySelector('[data-pp-add]');
      const buy = form.querySelector('[data-pp-buy-now]');
      const stickyAdd = section.querySelector('[data-pp-sticky-add]');
      const packages = [...form.querySelectorAll('[data-pp-package]')];
      // Match the server default even if the browser restores a previous form choice.
      if (select) {
        const initialOption = [...select.options].find(option => option.defaultSelected);
        if (initialOption) select.value = initialOption.value;
        packages.forEach(radio => radio.checked = radio.value === select.value);
      }
      packages.forEach(radio => radio.addEventListener('change', () => {
        if (!radio.checked || !select) return;
        select.value = radio.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      const date = section.querySelector('[data-pp-delivery-date]');
      if (date) {
        const arrival = new Date(Date.now() + Number(date.dataset.days || 7) * 86400000);
        date.textContent = new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'long', timeZone: 'America/Mexico_City' }).format(arrival);
      }
      if (select) select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        section.querySelectorAll('[data-pp-price]').forEach(el => el.textContent = option.dataset.price);
        const compare = section.querySelector('[data-pp-compare]');
        if (compare) compare.textContent = option.dataset.compare || '';
        packages.forEach(radio => radio.checked = radio.value === select.value);
        [add, buy, stickyAdd].forEach(button => { if (button) button.disabled = !available; });
        add.dataset.available = String(available);
        add.querySelector('[data-pp-add-label]').textContent = available ? add.dataset.label : add.dataset.soldOut;
        const url = new URL(window.location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
        if (stickyAdd) stickyAdd.textContent = available ? add.dataset.label : add.dataset.soldOut;
        const slides = [...section.querySelectorAll('.pp-gallery-slide')];
        const index = slides.findIndex(el => el.dataset.mediaId === option.dataset.mediaId);
        const track = section.querySelector('[data-pp-gallery-track]');
        if (index >= 0) track.scrollTo({ left: index * track.clientWidth, behavior: motion ? 'smooth' : 'auto' });
      });
      let purchasing = false;
      form.addEventListener('submit', async event => {
        const direct = section.dataset.directCheckout === 'true';
        const useDrawer = !direct && !!drawer() && event.submitter !== buy;
        if (!direct && !useDrawer && (!buy || event.submitter !== buy)) return;
        event.preventDefault();
        if (purchasing || cartBusy || add.disabled || !form.reportValidity()) return;
        purchasing = true;
        const error = form.querySelector('[data-pp-error]');
        error.hidden = true;
        const buttons = [add, buy, stickyAdd].filter(Boolean);
        buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
        packages.forEach(radio => radio.disabled = true);
        const payload = new FormData(form);
        const addUrl = direct || useDrawer ? section.dataset.addUrl : buy.dataset.addUrl;
        const checkout = direct || useDrawer ? section.dataset.checkout : buy.dataset.checkout;
        if (useDrawer) {
          payload.set('sections', 'cart-drawer'); payload.set('sections_url', window.location.pathname);
          cartBusy = true;
          setCartPending(true);
          openCart(add);
        }
        try {
          const response = await fetch(addUrl + '.js', { method: 'POST', body: payload, headers: { Accept: 'application/json' } });
          const state = await response.json();
          if (!response.ok) throw new Error(section.dataset.error);
          if (useDrawer) {
            const wasOpen = !drawer().hidden;
            renderCart(state);
            if (wasOpen) openCart(add);
          }
          else window.location.assign(checkout);
        } catch (problem) {
          error.textContent = section.dataset.error; error.hidden = false;
          if (useDrawer) {
            const cartError = drawer().querySelector('[data-pp-cart-error]');
            cartError.textContent = section.dataset.error; cartError.hidden = false;
          }
        } finally {
          purchasing = false;
          if (useDrawer) { cartBusy = false; setCartPending(false); }
          buttons.forEach(button => { button.disabled = add.dataset.available !== 'true'; button.removeAttribute('aria-busy'); });
          packages.forEach(radio => { radio.disabled = select.querySelector(`option[value="${radio.value}"]`)?.dataset.available !== 'true'; });
        }
      });
      const sticky = section.querySelector('[data-pp-sticky]');
      const buyArea = section.querySelector('.pp-buy');
      if (sticky && buyArea && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; });
        observer.observe(buyArea);
      }
    });
    scope.querySelectorAll('.pp video').forEach(video => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      const load = () => {
        if (video.dataset.poster) { video.poster = video.dataset.poster; delete video.dataset.poster; }
        const source = video.querySelector('source[data-src]');
        if (source) { source.src = source.dataset.src; source.removeAttribute('data-src'); video.load(); }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { const visible = entries[0].isIntersecting; if (visible) { load(); if (video.hasAttribute('data-pp-autoplay') && motion) video.play().catch(() => {}); } else video.pause(); }, { rootMargin: '100px' });
        observer.observe(video);
      } else load();
      video.addEventListener('pointerdown', load, { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
